import type { TranslationMessages } from "ra-core";

export const spanishRaMessages: TranslationMessages = {
  ra: {
    action: {
      add_filter: "Añadir filtro",
      add: "Añadir",
      back: "Volver",
      bulk_actions:
        "1 elemento seleccionado |||| %{smart_count} elementos seleccionados",
      cancel: "Cancelar",
      clear_array_input: "Vaciar la lista",
      clear_input_value: "Borrar valor",
      clone: "Duplicar",
      confirm: "Confirmar",
      create: "Crear",
      create_item: "Crear %{item}",
      delete: "Borrar",
      edit: "Editar",
      export: "Exportar",
      list: "Lista",
      refresh: "Actualizar",
      remove_filter: "Quitar este filtro",
      remove_all_filters: "Quitar todos los filtros",
      remove: "Quitar",
      reset: "Restablecer",
      save: "Guardar",
      search: "Buscar",
      search_columns: "Buscar columnas",
      select_all: "Seleccionar todo",
      select_all_button: "Seleccionar todo",
      select_row: "Seleccionar esta fila",
      show: "Mostrar",
      sort: "Ordenar",
      undo: "Deshacer",
      unselect: "Deseleccionar",
      expand: "Desplegar",
      close: "Cerrar",
      open_menu: "Abrir menú",
      close_menu: "Cerrar menú",
      update: "Actualizar",
      move_up: "Subir",
      move_down: "Bajar",
      open: "Abrir",
      toggle_theme: "Cambiar entre modo claro y oscuro",
      select_columns: "Columnas",
      update_application: "Recargar la aplicación",
    },
    boolean: {
      true: "Sí",
      false: "No",
      null: " ",
    },
    page: {
      create: "Crear %{name}",
      dashboard: "Panel",
      edit: "%{name} %{recordRepresentation}",
      error: "Algo ha ido mal",
      list: "%{name}",
      loading: "Cargando",
      not_found: "No encontrado",
      show: "%{name} %{recordRepresentation}",
      empty: "Todavía no hay %{name}.",
      invite: "¿Quieres añadir uno?",
      access_denied: "Acceso denegado",
      authentication_error: "Error de autenticación",
    },
    input: {
      file: {
        upload_several:
          "Arrastra aquí los archivos que quieras subir o haz clic para seleccionar uno.",
        upload_single:
          "Arrastra aquí el archivo que quieras subir o haz clic para seleccionarlo.",
      },
      image: {
        upload_several:
          "Arrastra aquí las imágenes que quieras subir o haz clic para seleccionar una.",
        upload_single:
          "Arrastra aquí la imagen que quieras subir o haz clic para seleccionarla.",
      },
      references: {
        all_missing: "No se han podido encontrar los datos de referencia.",
        many_missing:
          "Al menos una de las referencias asociadas ya no parece estar disponible.",
        single_missing: "La referencia asociada ya no parece estar disponible.",
      },
      password: {
        toggle_visible: "Ocultar contraseña",
        toggle_hidden: "Mostrar contraseña",
      },
    },
    message: {
      about: "Acerca de",
      access_denied: "No tienes permisos para acceder a esta página",
      are_you_sure: "¿Estás seguro?",
      authentication_error:
        "El servidor de autenticación ha devuelto un error y no se han podido verificar tus credenciales.",
      auth_error:
        "Se ha producido un error al validar el token de autenticación.",
      bulk_delete_content:
        "¿Seguro que quieres borrar este %{name}? |||| ¿Seguro que quieres borrar estos %{smart_count} elementos?",
      bulk_delete_title: "Borrar %{name} |||| Borrar %{smart_count} %{name}",
      bulk_update_content:
        "¿Seguro que quieres actualizar %{name} %{recordRepresentation}? |||| ¿Seguro que quieres actualizar estos %{smart_count} elementos?",
      bulk_update_title:
        "Actualizar %{name} %{recordRepresentation} |||| Actualizar %{smart_count} %{name}",
      clear_array_input: "¿Seguro que quieres vaciar toda la lista?",
      delete_content: "¿Seguro que quieres borrar este %{name}?",
      delete_title: "Borrar %{name} %{recordRepresentation}",
      details: "Detalles",
      error:
        "Se ha producido un error en el cliente y no se ha podido completar la solicitud.",
      invalid_form: "El formulario no es válido. Revisa los errores.",
      loading: "Espera un momento",
      no: "No",
      not_found:
        "La dirección es incorrecta o el enlace que has seguido no es válido.",
      select_all_limit_reached:
        "Hay demasiados elementos para seleccionarlos todos. Solo se han seleccionado los primeros %{max}.",
      unsaved_changes:
        "Algunos cambios no se han guardado. ¿Seguro que quieres descartarlos?",
      yes: "Sí",
      placeholder_data_warning:
        "Problema de red: no se han podido actualizar los datos.",
    },
    navigation: {
      clear_filters: "Quitar filtros",
      no_filtered_results: "No hay %{name} con los filtros actuales.",
      no_results: "No hay resultados de %{name}",
      no_more_results:
        "La página %{page} está fuera de rango. Prueba con la página anterior.",
      page_out_of_boundaries: "La página %{page} está fuera de rango",
      page_out_from_end: "No se puede ir más allá de la última página",
      page_out_from_begin: "No se puede ir antes de la página 1",
      page_range_info: "%{offsetBegin}-%{offsetEnd} de %{total}",
      partial_page_range_info:
        "%{offsetBegin}-%{offsetEnd} de más de %{offsetEnd}",
      current_page: "Página %{page}",
      page: "Ir a la página %{page}",
      first: "Ir a la primera página",
      last: "Ir a la última página",
      next: "Ir a la página siguiente",
      previous: "Ir a la página anterior",
      page_rows_per_page: "Filas por página:",
      skip_nav: "Saltar al contenido",
    },
    sort: {
      sort_by: "Ordenar por %{field_lower_first} %{order}",
      ASC: "ascendente",
      DESC: "descendente",
    },
    auth: {
      auth_check_error: "Inicia sesión para continuar",
      user_menu: "Perfil",
      username: "Usuario",
      password: "Contraseña",
      email: "Correo electrónico",
      sign_in: "Iniciar sesión",
      sign_in_error: "Error de autenticación, inténtalo de nuevo",
      logout: "Cerrar sesión",
    },
    notification: {
      updated:
        "Elemento actualizado |||| %{smart_count} elementos actualizados",
      created: "Elemento creado",
      deleted: "Elemento borrado |||| %{smart_count} elementos borrados",
      bad_item: "Elemento incorrecto",
      item_doesnt_exist: "El elemento no existe",
      http_error: "Error de comunicación con el servidor",
      data_provider_error:
        "Error del dataProvider. Consulta la consola para ver los detalles.",
      i18n_error:
        "No se han podido cargar las traducciones del idioma indicado",
      canceled: "Acción cancelada",
      logged_out: "Tu sesión ha terminado. Vuelve a conectarte.",
      not_authorized: "No tienes autorización para acceder a este recurso.",
      application_update_available: "Hay una nueva versión disponible.",
      offline: "Sin conexión. No se han podido obtener los datos.",
    },
    validation: {
      required: "Obligatorio",
      minLength: "Debe tener al menos %{min} caracteres",
      maxLength: "Debe tener como máximo %{max} caracteres",
      minValue: "Debe ser como mínimo %{min}",
      maxValue: "Debe ser como máximo %{max}",
      number: "Debe ser un número",
      email: "Debe ser un correo electrónico válido",
      oneOf: "Debe ser uno de estos valores: %{options}",
      regex: "Debe tener un formato concreto (regexp): %{pattern}",
      unique: "Debe ser único",
    },
    saved_queries: {
      label: "Consultas guardadas",
      query_name: "Nombre de la consulta",
      new_label: "Guardar la consulta actual...",
      new_dialog_title: "Guardar la consulta actual como",
      remove_label: "Borrar consulta guardada",
      remove_label_with_name: 'Borrar la consulta "%{name}"',
      remove_dialog_title: "¿Borrar la consulta guardada?",
      remove_message:
        "¿Seguro que quieres quitar este elemento de tu lista de consultas guardadas?",
      help: "Filtra la lista y guarda esta consulta para más tarde",
    },
    guesser: {
      empty: {
        title: "No hay datos que mostrar",
        message: "Revisa tu proveedor de datos",
      },
    },
    configurable: {
      customize: "Personalizar",
      configureMode: "Configurar esta página",
      inspector: {
        title: "Inspector",
        content:
          "Pasa el ratón por encima de los elementos de la interfaz para configurarlos",
        reset: "Restablecer ajustes",
        hideAll: "Ocultar todo",
        showAll: "Mostrar todo",
      },
      Datagrid: {
        title: "Tabla de datos",
        unlabeled: "Columna sin etiqueta n.º %{column}",
      },
      SimpleForm: {
        title: "Formulario",
        unlabeled: "Campo sin etiqueta n.º %{input}",
      },
      SimpleList: {
        title: "Lista",
        primaryText: "Texto principal",
        secondaryText: "Texto secundario",
        tertiaryText: "Texto terciario",
      },
    },
  },
};

export const raSupabaseSpanishMessages = {
  "ra-supabase": {
    auth: {
      email: "Correo electrónico",
      confirm_password: "Confirmar contraseña",
      sign_in_with: "Iniciar sesión con %{provider}",
      forgot_password: "¿Has olvidado tu contraseña?",
      reset_password: "Restablecer contraseña",
      password_reset:
        "Se ha restablecido tu contraseña. Recibirás un correo electrónico con un enlace para iniciar sesión.",
      missing_tokens: "Faltan los tokens de acceso y de actualización",
      back_to_login: "Volver al inicio de sesión",
    },
    reset_password: {
      forgot_password: "¿Has olvidado tu contraseña?",
      forgot_password_details:
        "Introduce tu correo electrónico para recibir las instrucciones.",
    },
    set_password: {
      new_password: "Elige tu contraseña",
    },
    validation: {
      password_mismatch: "Las contraseñas no coinciden",
    },
  },
};
